import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SidebarMenuItem from "./sidebar-menu-item/SidebarMenuItem";
import styles from "./Sidebar.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faPlus,
  faList,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../../../../assets/img/UNIG-Logo-Icon.png";
import { apps } from "../../../../constants/data";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function Sidebar() {
  let activePolicy = useSelector((state) => state.policies.activePolicy);
  let agent = useSelector((state) => state.user.agentInfo);
  let user = useSelector((state) => state.user.userInfo);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [isOpen, setIsOpen] = useState();
  let containerStyle;
  let app = useSelector((state) => state.app.app);
  let isAnon = useSelector((state) => state.app.isAnonymous);

  if (isOpen) {
    if (windowDimensions.width > 950) {
      containerStyle = `${styles.container}`;
    } else {
      containerStyle = `${styles.container} ${styles.floating} ${styles.open}`;
    }
  } else {
    if (windowDimensions.width > 950) {
      containerStyle = `${styles.container} ${styles.floating} ${styles.closed}`;
    } else {
      containerStyle = `${styles.container} ${styles.floating} ${styles.closed}`;
    }
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    windowDimensions.width < 950 ? setIsOpen(false) : setIsOpen(true);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  return (
    <div className={`${containerStyle} noselect`}>
      <div className={styles.contentContainer}>
        <span className={styles.date}>{new Date().toDateString()}</span>
        <FontAwesomeIcon
          className={styles.icon}
          icon={faBars}
          size="1x"
          onClick={() => setIsOpen(!isOpen)}
        />
        <img className={styles.logo} src={logo} role="presentation" alt="" />
        {(isAnon || (user && app === apps.Claims)) && (
          <Link to={isAnon ? "/fileaclaim" : "/new"}>
            <SidebarMenuItem text="New Claim" icon={faPlus} />
          </Link>
        )}
        {!isAnon && user && app === apps.Claims && (
          <Link to="/view">
            <SidebarMenuItem text="View Claims" icon={faList} />
          </Link>
        )}
        {agent && app === apps.Claims && (
          <Link to="/policies">
            <SidebarMenuItem text="Policies" icon={faFileAlt} />
          </Link>
        )}
        {agent && app === apps.DriveRight && (
          <Link to="/mlumpolicies">
            <SidebarMenuItem text="Policies" icon={faFileAlt} />
          </Link>
        )}
        {activePolicy && app === apps.DriveRight && (
          <Link to="/operators">
            <SidebarMenuItem text="Operators" icon={faFileAlt} />
          </Link>
        )}
      </div>
      {activePolicy && (
        <div className={styles.contentContainer}>
          <div className={styles.activePolicyContainer}>
            <span className={styles.activePolicy}>
              <strong>Active Policy: </strong>
              {activePolicy.PolicyNumber}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
